export default __webpack_public_path__ + "static/media/content-deco-3.ffd54c7a.webp";